import type { ReactNode } from "react";

type LabeledValueProperties = Readonly<{
  label: ReactNode;
  subLabel?: ReactNode;
  value?: string;
  /** When provided, the label renders as a clickable link instead of plain text (e.g. to open an informational popup) and this fires on click. */
  onLabelClick?: () => void;
}>;

/** A static label/value pair for displaying a value that's never editable — no input, just text, for fields that never need the disabled-input treatment. */
export function LabeledValue({ label, subLabel, value, onLabelClick }: LabeledValueProperties) {
  const labelClassName =
    "text-primary text-(length:--typography-base-sizes-extra-small-font-size)/(--typography-base-sizes-extra-small-line-height) font-(--font-weight-semibold)";
  return (
    <div className="gap-(--spacing-1) flex flex-col">
      <div className="flex flex-col">
        {onLabelClick ? (
          <button
            type="button"
            onClick={onLabelClick}
            className={`${labelClassName} w-fit text-left underline underline-offset-2`}
          >
            {label}
          </button>
        ) : (
          <span className={labelClassName}>{label}</span>
        )}
        {subLabel && <span className="text-primary text-[10px]">{subLabel}</span>}
      </div>
      <span className="text-(length:--typography-base-sizes-extra-small-font-size)/(--typography-base-sizes-extra-small-line-height)">
        {value}
      </span>
    </div>
  );
}
